type ShowcaseProductIdentity = {
  id: string
}

const hashShowcasePosition = (value: string) => {
  let hash = 2166136261

  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index)
    hash = Math.imul(hash, 16777619)
  }

  return hash >>> 0
}

export const orderProductsForShowcase = <T extends ShowcaseProductIdentity>(
  products: T[],
  showcaseKey: string
) => (
  [...products].sort((left, right) => {
    const scoreDifference = hashShowcasePosition(`${showcaseKey}:${left.id}`)
      - hashShowcasePosition(`${showcaseKey}:${right.id}`)

    if (scoreDifference !== 0) return scoreDifference

    return left.id.localeCompare(right.id, 'en', { numeric: true })
  })
)
